<template>
  <dd
    v-if="featureIncluded && featureDetails"
    :class="`${plan.slug} cell text-center padding-sm strong margin-bottom-0 display-flex`"
    style="background-color: var(--white); border: var(--border-width-sm) solid var(--fa-lt-gravy); flex: 1 0 0px; place-content: center; overflow: hidden"
  >
    <span
      v-if="featureDetails === 'Unlimited'"
      :aria-label="`${featureDetails}`"
      data-balloon-pos="right"
    >
      <font-awesome-icon
        :icon="$v6.solid.faInfinity"
        size="lg"
        class="decorative"
      />
      <span class="sr-only">included in the {{ plan.name }} plan</span>
    </span>
    <span v-else>
      {{ featureDetails }}
      <span class="sr-only">included in the {{ plan.name }} plan</span>
    </span>
  </dd>
  <dd
    v-else-if="featureIncluded"
    :class="`${plan.slug} cell flex-column text-center padding-sm margin-bottom-0 display-flex`"
    style="background-color: var(--white); border: var(--border-width-sm) solid var(--fa-lt-gravy); flex: 1 0 0px; place-content: center"
  >
    <span>
      <span
        aria-label="Included"
        data-balloon-pos="right"
      >
        <font-awesome-icon
          :icon="$v6.solid.faCircleCheck"
          size="xl"
          class="decorative"
        />
        <span class="sr-only">Included in the {{ plan.name }} plan</span>
      </span>
    </span>
  </dd>
  <dd
    v-else
    :class="`${plan.slug} cell flex-column text-center padding-sm margin-bottom-0 display-flex`"
    style="
      background-color: var(--white);
      color: var(--fa-gravy);
      border: var(--border-width-sm) solid var(--fa-lt-gravy);
      flex: 1 0 0px;
      place-content: center;
    "
  >
    <span>
      <span
        aria-label="Not Included"
        data-balloon-pos="right"
      >
        <font-awesome-icon
          :icon="$v6.solid.faBan"
          size="xl"
          class="decorative"
        />
        <span class="sr-only">Not Included in the {{ plan.name }} plan</span>
      </span>
    </span>
  </dd>
</template>

<script>
  import { get } from 'lodash'

  export default {
    name: 'TableCell',

    props: {
      plan: {
        type: Object
      },
      handleFunction: {
        type: Function
      }
    },

    data() {
      return {
        featureDetails: {
          type: String
        }
      }
    },

    computed: {
      featureIncluded() {
        const inclusion = this.handleFunction(this.plan)
        this.setFeatureDetails(inclusion)

        return get(inclusion, ['included'], false)
      }
    },

    methods: {
      setFeatureDetails(inclusion) {
        this.featureDetails = get(inclusion, ['decorator'], null)
      }
    }
  }
</script>
